import React from 'react';

import Text from '@amzn/meridian/text';

export const NoPermission = () => {
    return <Text>You do not have permission to view the page.</Text>;
};
